import { ControlLink, ControlLinkProps } from '@moda/om';
import React from 'react';
import { triggerPopup } from '../../lib/triggerPopup';

type Props = React.HTMLProps<HTMLAnchorElement> & ControlLinkProps;

export const PopupLink: React.FC<Props> = ({ href, children, ...rest }) => (
  <ControlLink href={href} onClick={triggerPopup} {...rest}>
    {children}
  </ControlLink>
);
